import api from '../config/api';

export interface PublicQuestion {
  id: number;
  question: string;
  answer: string | null;
  answer_video: string | null;
  status: 'pending' | 'answered' | 'published' | 'archived';
  is_public: boolean;
  user: number | null;
  user_name: string | null;
  user_email: string | null;
  answered_by: number | null;
  author_name: string;
  answered_by_name: string | null;
  is_my_question?: boolean;
  created_at: string;
  answered_at: string | null;
  updated_at: string;
}

export interface PublicQuestionList {
  id: number;
  question: string;
  answer: string | null;
  answer_video: string | null;
  status: string;
  author_name: string;
  is_my_question?: boolean;
  created_at: string;
  answered_at: string | null;
}

export interface PublicQuestionsData {
  count: number;
  next: string | null;
  previous: string | null;
  results: PublicQuestion[];
}

export interface MyQuestionsData {
  count: number;
  questions: PublicQuestionList[];
}

export const publicQuestionsService = {
  // Obtenir toutes les questions publiques (répondues et publiées)
  getAllQuestions: async (page: number = 1): Promise<PublicQuestionsData> => {
    const response = await api.get('/chat/public-questions/', {
      params: { page }
    });
    return response.data;
  },

  // Créer une nouvelle question publique
  createQuestion: async (question: string): Promise<PublicQuestion> => {
    const response = await api.post('/chat/public-questions/', { question });
    return response.data;
  },

  // Obtenir les questions de l'utilisateur connecté
  getMyQuestions: async (): Promise<MyQuestionsData> => {
    const response = await api.get('/chat/public-questions/my_questions/');
    return response.data;
  },

  // Obtenir une question spécifique
  getQuestionById: async (id: number): Promise<PublicQuestion> => {
    const response = await api.get(`/chat/public-questions/${id}/`);
    return response.data;
  },

  // Admin: Répondre à une question
  answerQuestion: async (id: number, answer?: string, answerVideo?: File): Promise<PublicQuestion> => {
    const formData = new FormData();
    if (answer) {
      formData.append('answer', answer);
    }
    if (answerVideo) {
      formData.append('answer_video', answerVideo);
    }
    const response = await api.post(`/chat/public-questions/${id}/answer/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Admin: Publier une question
  publishQuestion: async (id: number): Promise<PublicQuestion> => {
    const response = await api.post(`/chat/public-questions/${id}/publish/`);
    return response.data;
  },

  // Admin: Archiver une question
  archiveQuestion: async (id: number): Promise<PublicQuestion> => {
    const response = await api.post(`/chat/public-questions/${id}/archive/`);
    return response.data;
  },

  // Admin: Obtenir les questions sans réponse
  getUnansweredQuestions: async (): Promise<MyQuestionsData> => {
    const response = await api.get('/chat/public-questions/unanswered/');
    return response.data;
  },
};

